import { ICON__magnifying_glass } from '@/assets/icons_fa';
import { UI_PRIMITIVE__input } from '@/components/ui/UI_PRIMITIVE__input';
import i18n_page_diffusion_models from '@/locales/keys/i18n_page_diffusion_models.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { ChangeEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  on_change: (value: string) => void;
}

export const DiffusionModelsFilterInputSearch: React.FC<Props> = ({ on_change }) => {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_DIFFUSION_MODELS);

  const [value, set_value] = useState('');

  /*
   * EVENTS
   */

  function onChange(e: ChangeEvent<HTMLInputElement>) {
    set_value(e.target.value);

    on_change(e.target.value);
  }

  return (
    <UI_PRIMITIVE__input
      placeholder={t(i18n_page_diffusion_models.input.search)}
      className="w-full h-[40px]"
      iconStart={<ICON__magnifying_glass className="!w-3.5 !h-3.5 !text-component-item-foreground" />}
      {...{ value, onChange }}
    />
  );
};
